module.exports = __webpack_public_path__ + "img/effects-18.bb8d7f3d.png";